'use client'

import { QueryClientProvider } from '@tanstack/react-query'
import { OfflineProvider } from './offline-context'
import { ThemeProvider } from './theme-provider'
import { AuthProvider } from '@/hooks/useAuth'
import { AnalyticsProvider } from './analytics-provider'
import { queryClient } from '@/lib/query-client'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <OfflineProvider>
        <ThemeProvider defaultTheme="system" storageKey="miaozi-theme">
          <AuthProvider>
            <AnalyticsProvider>{children}</AnalyticsProvider>
          </AuthProvider>
        </ThemeProvider>
      </OfflineProvider>
    </QueryClientProvider>
  )
}
